export const RESPONSIVE_GRID_SINGLE_COLUMN_BREAKPOINT_PX = 1024;

export const RESPONSIVE_GRID_SINGLE_COLUMN_CLASS_NAME =
  'max-[1024px]:grid max-[1024px]:grid-cols-1';

export const RESPONSIVE_GRID_SINGLE_COLUMN_CONTENTS_CLASS_NAME = 'max-[1024px]:contents';

export const RESPONSIVE_GRID_TWO_TO_ONE_COLUMN_CLASS_NAME =
  'grid grid-cols-2 max-[1024px]:grid-cols-1';

export const RESPONSIVE_GRID_SINGLE_COLUMN_ORDER_CLASS_NAMES = [
  'max-[1024px]:order-1',
  'max-[1024px]:order-2',
  'max-[1024px]:order-3',
  'max-[1024px]:order-4',
  'max-[1024px]:order-5',
  'max-[1024px]:order-6',
  'max-[1024px]:order-7',
] as const;
